import React, { useEffect, useState } from "react";
import "./footer.css";
import "./footer.scss";

import { AiFillFacebook, AiOutlineInstagram } from "react-icons/ai";
import { FaTwitter, FaLinkedinIn } from "react-icons/fa";
import { MdOutlineTravelExplore } from "react-icons/md";
import logo from '../../assets/logo.jpg';

import Aos from "aos";
import "aos/dist/aos.css";

const Footer = () => {
  const [settings, setSettings] = useState({});

  useEffect(() => {
    fetch("https://orangered-hornet-549881.hostingersite.com/api/settings")
      .then((res) => res.json())
      .then((data) => setSettings(data));
    Aos.init({ duration: 2000 });
  }, []);

  return (
    <section className="footer section">
      <div className="footerContainer container grid">
        {/* Logo & About */}
        <div className="footerLeft">
          <div className="logo">
<img 
  src={logo} 
  alt="Yalla Egypt Tours" 
  style={{ borderRadius: "25px",
    width: "50px",
    height: "50px"
   }} 
/>
            <span>Yalla Egypt Tours</span>
          </div>
          <p>
            Content of a page when looking at layout the point of using lorem the
            is Ipsum less when looking normal
          </p>
          <div className="footerSocials">
            {settings.facebook && (
              <a href={settings.facebook} target="_blank" rel="noreferrer">
                <AiFillFacebook />
              </a>
            )}
            {settings.instagram && (
              <a href={settings.instagram} target="_blank" rel="noreferrer">
                <AiOutlineInstagram />
              </a>
            )}
            {settings.twitter && (
              <a href={settings.x} target="_blank" rel="noreferrer">
                <FaTwitter />
              </a>
            )}
            {settings.linkedin && (
              <a href={settings.linkedin} target="_blank" rel="noreferrer">
                <FaLinkedinIn />
              </a>
            )}
          </div>
        </div>

        {/* Useful Links */}
        <div className="footerLinks">
          <h3>Useful Links</h3>
          <ul>
            <li>
              <a href="/">Home</a>
            </li>
             <li>
              <a href="/packages">Packages</a>
            </li>
             <li>
              <a href="/tours">Tours</a>
            </li>
            <li>
              <a href="/about-us">About us</a>
            </li>
           
            <li>
              <a href="/contact">Contact Us</a>
            </li>
           
          </ul>
        </div>

        {/* Day Tours */}
        {/* <div className="footerLinks">
          <h3>Day Tours</h3>
          <ul>
            <li>
              <a href="#">Cairo Day Tours</a>
            </li>
            <li>
              <a href="#">Luxor Day Tours</a>
            </li>
            <li>
              <a href="#">Hurghada Day Tours</a>
            </li>
            <li>
              <a href="#">Cookie Policy</a>
            </li>
          </ul>
        </div> */}

        {/* Contact & Payments */}
        <div className="footerRight">
          <h3>Get In Touch</h3>
          <p>
            <i className="fas fa-envelope"></i> {settings.email}
          </p>
          <p>
            <i className="fas fa-phone"></i> {settings.phone}
          </p>
          <p>Los Angeles - California. USA</p>

          <h4>Payment Method</h4>
          <div className="paymentIcons">
            <img
              src="https://img.icons8.com/color/48/visa.png"
              alt="Visa"
            />
            <img
              src="https://img.icons8.com/color/48/mastercard-logo.png"
              alt="MasterCard"
            />
            <img
              src="https://img.icons8.com/color/48/amex.png"
              alt="Amex"
            />
            <img
              src="https://img.icons8.com/color/48/paypal.png"
              alt="Paypal"
            />
          </div>
        </div>
      </div>

      <div className="footerBottom">
        <p>
          {settings.footer_text
            ? settings.footer_text
            : "Copyright © 2025 Samer All Right Reserved"}
        </p>
      </div>
    </section>
  );
};

export default Footer;
